<template>
  <b-card title="ผลการค้นหา">
    

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      ref="my-table"
      @on-selected-rows-change="selectionChanged"
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength,
      }"
      @on-page-change="onPageChange"
        @on-per-page-change="onPageLengthChange"
        :totalRows="totalRecords"
    >
    <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field == 'companyName'">
          <feather-icon icon="BriefcaseIcon" class="mr-50" />ผู้ประกอบการ /
          <feather-icon icon="UserIcon" class="mr-50" />ชื่อผู้ร้องทุกข์ /
          <feather-icon icon="UsersIcon" class="mr-50" /> ผู้มอบอำนาจ
        </span>
        <span v-else>
          {{ props.column.label }}
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'complaintCode'" class="text-nowrap">
          <!-- <b-avatar
            :src="props.row.avatar"
            class="mx-1"
          /> -->
          <span class="text-nowrap">{{ props.row.complaintCode }}</span>
          <br />
          <span class="text-nowrap"
            ><i class="flaticon2-open-text-book" />
            {{ props.row.sarabunCode }}</span
          >
        </span>

        <!-- Column: Name -->
        <span v-if="props.column.field === 'companyName'" class="text-nowrap">
          <span
            v-if="props.row.companyName !== null"
            class="text-nowrap"
            v-b-tooltip.hover
            :title="props.row.companyName"
          >
            <feather-icon icon="BriefcaseIcon" class="mr-50" />
            {{ props.row.companyName.substring(0, 50)
            }}{{ props.row.companyName.length >= 50 ? "..." : "" }}
          </span>
          <br />
              

          <span v-for="(item, index) in props.row.complainantJsonList.filter(function (value) {return value.role === 3})" :key="index" class="text-nowarp">
            <feather-icon icon="UserIcon" class="mr-50" />{{item.fName}} {{item.lName}}
            <br />
          </span>

          <span v-for="(item, index) in props.row.complainantJsonList.filter(function (value) {return value.role === 8})" :key="index" class="text-nowarp">
            <feather-icon icon="UsersIcon" class="mr-50" />{{item.fName}} {{item.lName}}
            <br />
          </span>
        </span>
        <!-- Column: Complain_Subject -->
        <span v-if="props.column.field === 'status'" class="text-nowrap">
          <span class="text-nowrap">
            {{ props.row.complaintDateStr }} - {{ props.row.slaDate }}
          </span>
          <br />
          <span class="text-nowarp">
            {{ props.row.leveldescription }}-{{ props.row.statusdescription }}
          </span>
          <br />
          <span class="text-nowarp">
            {{ props.row.channelName }}
          </span>
        </span>
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="text-body align-middle mr-25"
                >
                  <feather-icon icon="SettingsIcon" class="mr-50" />
                  <span class="align-middle">จัดการ</span>
                </b-button>
              </template>
              <b-dropdown-item
                @click="onComplainGroupManage(props.row.complaintId)"
              >
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>จัดการข้อมูล</span>
              </b-dropdown-item>
              <b-dropdown-item @click="onComplaintFormClicked(props.row.complaintId)">
                <feather-icon icon="FileTextIcon" class="mr-50" />
                <span>ใบคำขอร้องทุกข์</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <!-- <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span> -->
      </template>

      <!-- pagination -->
      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <FileInput />
    <AttachFileList />
  </b-card>

</template>

<script>
import {
  BButton, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BCard, BCardHeader, BCardBody,VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'
import { codeBasic } from '@/views/table/vue-good-table/code'
import FileInput from '@/views/modals/FileInput.vue'
import AttachFileList from '@/views/modals/AttachFileList.vue'
import TableHeaders from './commonTableHeader.js'
import appsettings from '@/store/app-settings'
import * as ViewStore from '@/store/api/screening/screening.js'

import * as userData from "@/auth/localStorageUtils.js";

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    FileInput,
    AttachFileList,
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    TableHeaders,
    ViewStore,
    
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    }
  },
  data() {
    return {

      pageLength: 10,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      rows: [],
      searchTerm: '',
      params: {},
      totalRecords: 0,
      status: [{
        1: 'Current',
        2: 'Professional',
        3: 'Rejected',
        4: 'Resigned',
        5: 'Applied',
      },
      {
        1: 'light-primary',
        2: 'light-success',
        3: 'light-danger',
        4: 'light-warning',
        5: 'light-info',
      }],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current      : 'light-primary',
        Professional : 'light-success',
        Rejected     : 'light-danger',
        Resigned     : 'light-warning',
        Applied      : 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    //this.onSearchSubmit(null)
  },
  methods: {
    selectionChanged () {
      console.log('selectionChanged')
      this.$emit('handleSelect', this.$refs['my-table'].selectedRows )
    },
    onSearchSubmit(params, page = { currentPage: 1 }) {
      //console.log('onSearchSubmit', params)

      var _this = this

      // params.userActive = userData.userId();
      params.departmentId = userData.departmentId();
      params.page = page.currentPage;
      params.perPage = this.pageLength;

      _this.$emit("handleOverlay", true);

      ViewStore.ComplaintEditAdmin(params).then(function (response) {
        _this.rows = response.data.data
        try {
                _this.totalRecords = response.data.data[0].totalCount;
              } catch (ex) {
                console.log("get total records error", ex);
                _this.totalRecords = 0;
              }
      })
      .catch(function (error) {
        // handle error
        console.log('error',error);
      })
      .then(function () {
        _this.$emit("handleOverlay", false);
      });
      
    },
    onPageChange(page) {
      console.log("onPageChanged", page);
      this.onSearchSubmit(this.params, page);
    },
    onPageLengthChange(pageLength) {
      console.log("onPageLengthChanged", pageLength);
      this.onSearchSubmit(this.params, 1);
    },
    onComplainSend(id) {
      this.$emit('handleSend', id)
    },
    onComplainGroupManage(id) {
      this.$emit('handleGroup', id)
    },
    onComplaintFormClicked(id) {
      const url = appsettings.complaintFormUrl.replace('{0}', id)
      window.open(url, "_blank");
    },
    confirmText() {
      this.$swal({
        title: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        text: 'เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ลบข้อมูล',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$swal({
            icon: 'success',
            title: 'ลบข้อมูล สำเร็จ',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>
